import { useState } from 'react'
import BaseAppContainer from '../base--app-container/BaseAppContainer'
import Styles from './Contact.module.scss';
import LeftPanelMenu from '../left-panel-menu/LeftPanelMenu';
import BasicContactInfo from './basic-contact-info/BasicContactInfo';
import { APP_KEY_IDS } from '../../constants/constants';
import MyImage from "../../res/images/me.png"

export const CONTACTS = [
    {
        label: "P",
        options: [
            {
                id: "0",
                label: "Priyansh Datyal",
                designation:"Software Development Engineer",
                phone: "(091) 70187-*****",
                work: "priyansh.sk80@gmail.com",
                facetime: "",
                birthday: "June 15",
                home: "District Hamirpur, Himachal Pradesh, India",
                pfp:"https://firebasestorage.googleapis.com/v0/b/priyanshdatyal-me.appspot.com/o/website%20resources%2Fportfolio_profile_picture.webp?alt=media&token=8396fd2a-7b6e-452d-866b-b0aecf5077f0"
            }
        ]
    }
]

const Contact = () => {

    const [activeId, setActiveId] = useState("0")
    const [activeContact, setActiveContact] = useState(CONTACTS[0].options[0])



    return (
        <BaseAppContainer
            appId={APP_KEY_IDS.CONTACTS}
            loadFromX={30}
            width={900}
            height={600}
            title={"Contacts"}
            SideBar={
                <LeftPanelMenu menuContent={CONTACTS} showHeaderBorder={true} activeValue={activeId} handleOptionClick={setActiveId} />
            }
            MainScreen={
                <BasicContactInfo 
                    label={activeContact.label}
                    phone={activeContact.phone}
                    work={activeContact.work}
                    facetime={activeContact.facetime}
                    birthday={activeContact.birthday}
                    home={activeContact.home}
                    pfp={activeContact.pfp} 
                    designation={activeContact.designation}
                />
            }
        />
    )
}

export default Contact
